// Form doldurma — otomatik kayıt geri bildirimi tek kopya kaynağı (UX P1 K4/K5/Ö7).
// Satır içi string yazılmaz. Müşteri katılımcı da bu metinleri görür: "AI", "üretim",
// "danışman notu" ifadesi YASAK (e2e spec 09 `toHaveCount(0)` iddiaları).
// e2e spec 17'deki COPY bloğu elle eşlenik kopyadır — birini değiştirince diğerini de güncelle.
export const FORM_SAVE_COPY = {
  indicator: {
    typing: "Değişiklik bekleniyor…",
    saving: "Kaydediliyor…",
    saved: "Kaydedildi ✓",
    retry: "Yeniden deneniyor…",
    offline: "Çevrimdışı",
    syncing: "Senkronize ediliyor…",
    conflict: "Çakışma",
    /** Kalıcı istemci hatası — otomatik yeniden deneme YOK; değişiklikler tarayıcıda bekler. */
    failed: "Kaydedilemedi — sayfayı yenileyip tekrar deneyin",
  },
  /** Yalnız sunucunun reddettiği alanlar kaldı — yeniden deneme YOK, kullanıcı düzeltmeli. */
  invalid: (n: number): string => `${n.toString()} alan kaydedilemedi — düzeltin`,
  /** Başka alanlar kaydedilirken reddedilmiş alan da varsa göstergeye eklenen kısa ek. */
  invalidSuffix: (n: number): string => `· ${n.toString()} alan kaydedilemedi`,
  invalidGoTo: "İlk kaydedilemeyen alana git",
  /** Soru kartı — sunucunun reddettiği değer kartta durur ama kaydedilmedi. */
  cardUnsaved: "Bu alan kaydedilmedi — aşağıdaki sorunu düzeltin.",
  offlineQueued: (n: number): string => `${n.toString()} değişiklik kuyruğa alındı`,
  /** Eksik rozeti — sunucu durumunu gösterir; kaydedilmemiş değişiklik varsa bunu söyler. */
  missingBadge: (n: number): string => `${n.toString()} eksik`,
  missingNone: "Eksik yok ✓",
  missingUnsavedSuffix: (n: number): string => ` · ${n.toString()} kaydedilmedi`,
  missingUnsavedTitle:
    "Eksik sayısı son kaydedilen duruma göredir; kaydedilmemiş değişiklikler henüz sayılmadı.",
  /** Eksik paneli üst bloğu — kaydedilemeyen alanların listesi. */
  panelUnsavedTitle: (n: number): string => `${n.toString()} alan kaydedilemedi`,
  panelUnsavedLead:
    "Bu alanlar düzeltilene kadar kaydedilmez. Aşağıdaki eksik listesi son kaydedilen duruma göredir.",
  /** Müşteri gönderimi — kaydedilmemiş değişiklik varken gönderim durur. */
  submitBlocked: (hasInvalid: boolean): string =>
    hasInvalid
      ? "Kaydedilemeyen alanlar var — işaretli alanları düzeltin"
      : "Kaydedilemeyen cevaplarınız var — bağlantınızı kontrol edin",
  /** R1 — sunucu yazımı atladı: aynı alanın daha yeni değeri vardı (başka sekme/cihaz). */
  supersededCard: "Bu alanın daha yeni bir değeri var — sunucudaki değer yüklendi.",
  supersededMine: (v: string): string => `Yazdığınız değer: ${v}`,
  supersededApplyMine: "Benimkini uygula",
  supersededKeep: "Sunucudakini koru",
  supersededIndicator: (n: number): string =>
    `${n.toString()} alanın daha yeni değeri yüklendi — kontrol edin`,
  percentClear: "Temizle",
  percentClearAria: "Yüzde dağılımını temizle",
} as const;

/**
 * Danışman notu sınırı — yalnız iç kullanıcı yüzeyi (ConsultantNote müşteri dalında render
 * edilmez); bu yüzden müşteri kopyası FORM_SAVE_COPY'den ayrı tutulur.
 */
export const CONSULTANT_NOTE_COPY = {
  nearLimit: (n: number, max: number): string =>
    `${n.toLocaleString("tr-TR")} / ${max.toLocaleString("tr-TR")} karakter`,
  atLimit: (max: number): string =>
    `Not en fazla ${max.toLocaleString("tr-TR")} karakter olabilir — fazlası eklenmedi.`,
} as const;
